import i18n from '@/utils/i18n';
import CONSTANTS from '@/config/constants';

const { METHOD_GROUP, NODE_PARENT_INDEX } = CONSTANTS;

export function formatSortType(type) {
  if (type) {
    return type.includes('asc') ? type.substring(0, 3) : type.substring(0, 4);
  }
  return type;
}
export function setIsShow(status) {
  return !status;
}
export function getActionOfResource(endpoint) {
  const [product, service, action] = endpoint.split('.');
  return action;
}
export function getServiceName(data) {
  const condition = data.split('.');
  const [name, properties] = condition;
  return name;
}
export function formatConditionAll(data) {
  return data.map((item) => ({
    ...item,
    servicesName: getServiceName(item?.condition_name),
  }));
}
// validator data json convert
function isErrorAction(dataType, actionData, resourcesData) {
  if (!Array.isArray(actionData)) return false;
  if (actionData.some((item) => dataType.includes(typeof item))
    && actionData.length) return false;
  if (!actionData.length && resourcesData.length) return false;
  return true;
}
function isErrorResources(dataType, resourcesData, actionData) {
  if (!Array.isArray(resourcesData)) return false;
  if (resourcesData.some((item) => dataType.includes(typeof item))
    && resourcesData.length) return false;
  if (!resourcesData.length && actionData.length) return false;
  return true;
}
function isErrorCondition(dataType, conditionData) {
  const checkTypeCondition = Array.isArray(conditionData) || typeof conditionData === 'string';
  if (!checkTypeCondition) return false;
  if (conditionData.some((item) => dataType.includes(typeof item))
    && conditionData.length) return false;
  if (conditionData.some((item) => item.value.length > 255)
    && conditionData.length) return false;
  if (conditionData.length > 10) return false;
  return true;
}
function isNotEmptyData(data) {
  if (data.length) return true;
  return false;
}
function isErrorEffect(data) {
  if (typeof data !== 'string') return false;
  return true;
}
function isErrorDataJson(data, type) {
  const {
    action, resources, conditions, effect,
  } = data;
  const typeDataAction = ['object', 'boolean', 'number', 'undefined'];
  const typeDataCondition = ['boolean', 'number', 'undefined', 'string'];
  let result = true;
  if (!typeDataAction.includes(typeof data)) result = false;
  switch (type) {
    case 'action':
      result = isErrorAction(typeDataAction, action, resources);
      break;
    case 'resources':
      result = isErrorResources(typeDataAction, resources, action);
      break;
    case 'condition':
      result = isErrorCondition(typeDataCondition, conditions);
      break;
    case 'effect':
      result = isErrorEffect(effect);
      break;
    default:
      break;
  }
  return result;
}
export function isJson(data) {
  try {
    JSON.parse(data);
  } catch (e) {
    return false;
  }
  return true;
}
function isKeyJson(permissionObject) {
  const arrayKey = Object.keys(permissionObject);
  if ('version' in permissionObject
    && 'permissions' in permissionObject
    && arrayKey.length === 2) {
    return true;
  }
  return false;
}
function isString(data) {
  if (typeof data !== 'string') return false;
  return true;
}
function getFullResources(action, resources) {
  if (!Array.isArray(action) || !Array.isArray(resources)) return [];
  if (!action.length || !resources.length) return [];
  return resources.reduce((acc, currentValue) => {
    action.forEach((act) => acc.push(`${currentValue}.${act}`));
    return acc;
  }, []);
}
function getAllEndpoint(dataAll) {
  return dataAll.reduce((result, currentValue) => {
    const { resources } = currentValue;
    resources.forEach((item) => {
      const { endpoint, conditions } = item;
      result.endpointList.push(endpoint);
      if (conditions.length) {
        conditions.forEach((ele) => {
          if (!result.conditionList.includes(ele.condition_name)) {
            result.conditionList.push(ele.condition_name);
          }
        });
      }
    });
    return result;
  }, {
    endpointList: [],
    conditionList: [],
  });
}
function getErrorResources(fullResources, endpointAll) {
  const isError = fullResources
    .filter((endpoint) => !endpointAll.some((item) => item === endpoint));
  if (isError.length) return true;
  return false;
}
function isPermissions(permissions, dataResourcesAll) {
  if (Array.isArray(permissions)) {
    let invalid = true;
    let err = '';
    permissions.forEach((item) => {
      const {
        action, resources,
      } = item;
      const fullResources = getFullResources(action, resources);
      const isErrorFormat = isErrorDataJson(item, 'action')
        && isErrorDataJson(item, 'resources')
        && isErrorDataJson(item, 'condition')
        && isErrorDataJson(item, 'effect');
      const isDataFake = getErrorResources(fullResources, dataResourcesAll.endpointList);
      if (!isErrorFormat || isDataFake) {
        invalid = false;
        err = i18n.t('iam.notification.permissionItemError');
      }
    });
    return {
      status: invalid,
      mess: err,
    };
  }
  return {
    status: false,
    mess: i18n.t('form.validator.invalid', { field: 'Permissions' }),
  };
}
function isTypeKeyJson(permissionObject, allEndpoint) {
  // check typeof version
  if (!isString(permissionObject.version)) {
    return {
      status: false,
      mess: i18n.t('form.validator.invalid', { field: 'Version' }),
    };
  }
  // check typeof permission and data fake
  const isErrorPermissions = isPermissions(permissionObject.permissions, allEndpoint);
  if (!isErrorPermissions.status) {
    return {
      status: false,
      mess: isErrorPermissions.mess,
    };
  }
  return {
    status: true,
    mess: '',
  };
}
export function validateCommonJson(dataRole, dataAll) {
  // check format Json
  if (!isJson(dataRole)) {
    return {
      status: false,
      mess: i18n.t('iam.notification.syntaxError'),
    };
  }
  const convertDataObject = JSON.parse(dataRole);
  // check key json
  if (!isKeyJson(convertDataObject)) {
    return {
      status: false,
      mess: i18n.t('iam.notification.jsonError'),
    };
  }
  const allEndpoint = getAllEndpoint(dataAll);
  // check typeof key, data fake, max length condition
  const {
    status: errorData, mess: text,
  } = isTypeKeyJson(convertDataObject, allEndpoint);
  if (!errorData) {
    return {
      status: false,
      mess: text,
    };
  }
  return {
    status: true,
    mess: '',
  };
}
// end validator data json convert
// Common
function isDataDefault(dataRole) {
  if (dataRole.length === 1) {
    const { action, conditions, resources } = dataRole[0];
    if (!action.length
      && !resources.length
      && !conditions.length) return true;
  }
  return false;
}
function groupByActionOfResources(resources, property) {
  return resources.reduce((acc, currentValue) => {
    if (currentValue[property] in acc) {
      acc[currentValue[property]].push(currentValue);
    } else {
      acc[currentValue[property]] = [currentValue];
    }
    return acc;
  }, {});
}
function getListEndPoint(action, resources) {
  return action.reduce((result, act) => {
    resources.forEach((res) => {
      const endpointMerger = `${res}.${act}`;
      if (!result.endpointMerger
          .includes(endpointMerger)) result.endpointMerger.push(endpointMerger);
      if (!result.subEndpointAll
          .includes(res)) result.subEndpointAll.push(res);
    });
    return result;
  }, {
    endpointMerger: [],
    subEndpointAll: [],
  });
}
function groupResourcesMerge(resources) {
  return Object.keys(resources).reduce((result, key) => {
    const permission = {
      endpointAll: [],
      conditionAll: [],
      subEndpointAll: [],
      parent: key,
    };
    resources[key].forEach((ele) => {
      const {
        action, resources, conditions, effect,
      } = ele;
      if (isErrorDataJson(ele, 'action')
        && isErrorDataJson(ele, 'resources')
        && isErrorDataJson(ele, 'condition')
        && isErrorDataJson(ele, 'effect')) {
          const dataEndpointMerge = getListEndPoint(action, resources);
          dataEndpointMerge.endpointMerger.forEach((item) => {
            if (!permission.endpointAll.includes(item)) permission.endpointAll.push(item);
          });
          dataEndpointMerge.subEndpointAll.forEach((item) => {
            if (!permission.subEndpointAll.includes(item.split('.')[1])) {
              permission.subEndpointAll.push(item.split('.')[1]);
            }
          });
          if (conditions.length) {
            conditions.forEach((item) => {
              if (!permission.conditionAll.length) {
                permission.conditionAll.push(item);
              }
              if (!permission.conditionAll
                .some((ele) => JSON.stringify(ele) === JSON.stringify(item))
                && permission.conditionAll.length) {
                  permission.conditionAll.push(item);
                }
            });
            permission.conditionAll = permission.conditionAll.map((item) => (item));
          }
      } else {
        // eslint-disable-next-line no-param-reassign
        result = {
          status: false,
          dataMerge: [],
        };
      }
    });
    result.dataMerge.push(permission);
    return result;
  }, {
    status: true,
    dataMerge: [],
  });
}
// Process data role từ server
function groupResourcesMergeFromServer(resources) {
  const item = {
    endpointAll: [],
    conditionAll: [],
    subEndpointAll: [],
    parent: '',
  };
  return Object.keys(resources).reduce((result, key) => {
    const itemCopy = JSON.parse(JSON.stringify(item));
    if (resources[key].length === 1) {
      itemCopy.endpointAll = resources[key][0].endpointAll;
      itemCopy.conditionAll = resources[key][0].conditionAll;
      itemCopy.subEndpointAll = resources[key][0].subEndpointAll;
      itemCopy.parent = resources[key][0].parent;
    } else {
      itemCopy.parent = resources[key][0].parent;
      resources[key].forEach((ele) => {
        const {
          conditionAll, endpointAll, parent, subEndpointAll,
        } = ele;
        if (conditionAll.length) {
          conditionAll.forEach((e) => itemCopy.conditionAll.push(e));
        }
        endpointAll.forEach((e) => itemCopy.endpointAll.push(e));
        subEndpointAll.forEach((e) => itemCopy.subEndpointAll.push(e));
      });
    }
    result.dataMerge.push(itemCopy);
    return result;
  }, {
    status: true,
    dataMerge: [],
  });
}
export function groupByServices(permissions) {
  const item = {
    endpointAll: [],
    conditionAll: [],
    subEndpointAll: [],
    parent: '',
  };
  const formatData = permissions.reduce((acc, currentValue) => {
    const itemCopy = JSON.parse(JSON.stringify(item));
    const { conditions, resources } = currentValue;
    const [service, children, action] = resources[0].endpoint.split('.');
    itemCopy.parent = service;
    resources.forEach((resource) => {
      itemCopy.endpointAll.push(resource.endpoint);
      // sub endpoint
      if (!itemCopy.subEndpointAll.includes(resource.endpoint.split('.')[1])) {
        itemCopy.subEndpointAll.push(resource.endpoint.split('.')[1]);
      }
    });
    conditions.forEach((condition) => {
      itemCopy.conditionAll.push(condition);
    });
    acc.push(itemCopy);
    return acc;
  }, []);
  const groupByServiceParent = groupByActionOfResources(formatData, 'parent');
  return groupResourcesMergeFromServer(groupByServiceParent);
}
/*
  * NEW IMPROVE Permission
*/
/*
 * Parameters:
 * - listPermission: list all resource by service id
 * Returns:
 * - permission tree structure
 */
export function groupPermissionByType(listPermission) {
  const groupedPermissions = new Map();

  listPermission.forEach((item) => {
    const {
      method, nodeParentIndex, uuid, action,
      endpoint, description, conditions,
    } = item;
    const parent = groupedPermissions.get(method) || {
      id: nodeParentIndex,
      label: method,
      nodeParentIndex,
      description: '',
      isParent: true,
      resultSearch: 0,
      resultSelected: 0,
      disabled: false,
      children: [],
      conditions: [],
      action,
    };

    parent.children.push({
      id: uuid,
      label: endpoint,
      description,
      action,
      nodeParentIndex,
      isParent: false,
      disabled: false,
      children: [],
      conditions,
    });

    groupedPermissions.set(method, parent);
  });
  return Array.from(groupedPermissions.values())
      .sort((firstItem, secondItem) => firstItem.id - secondItem.id);
}
/*
 * Parameters:
 * - listResources: list all resource by service id
 * Returns:
 * - list permission with method by D5,design
 */
export function mappingMethods(listResources) {
  return listResources.map((item) => ({
    ...item,
    method: METHOD_GROUP[item.method],
    nodeParentIndex: NODE_PARENT_INDEX[METHOD_GROUP[item.method]],
    action: getActionOfResource(item.endpoint),
  }));
}
/*
 * Parameters:
 * - permission: new permission selected
 * - currentList: list permission selected (current)
 * Returns:
 * - new list permission selected
 */
export function getListPermissionSelectedChild(permission, currentList) {
  const indexPer = currentList
      .findIndex((item) => item?.id === permission?.id);
  if (indexPer === -1) {
    return [...currentList, permission];
  }
  return currentList.filter((_, index) => index !== indexPer);
}
/*
 * Parameters:
 * - listChild: list child permission if parent permission selected
 * - currentList: list permission selected (current)
 * Returns:
 * - new list permission selected
 */
export function getListPermissionSelectedByParent(listChild, currentList) {
  const listPermissionId = new Set(listChild.map((item) => item.id));
  const allExistPermission = listChild.every((per) => currentList
      .some((item) => item.id === per.id));
  if (allExistPermission) {
    return currentList.filter((item) => !listPermissionId.has(item.id));
  }
  const mergePermissions = [...currentList, ...listChild];
  return Array.from(new Set(mergePermissions.map((obj) => obj.id)))
      .map((id) => mergePermissions.find((obj) => obj.id === id));
}
function checkMultipleChildService(listEndpoint) {
  const uniquePrefixes = new Set();
  // eslint-disable-next-line
  for (let item of listEndpoint) {
    uniquePrefixes.add(item.split('.')[1]);
    if (uniquePrefixes.size > 1) {
      return true;
    }
  }
  return false;
}
export function checkDeleteCondition(name, index, totalCondition, disable) {
  if (disable) return false;
  return !(!index && name === '' && totalCondition === 1);
}
export function getDataRoleNew(roles, indexPermission) {
  if (indexPermission !== '') {
    roles.splice(indexPermission, 1);
  }
  return roles.map((role, index) => ({
    ...role,
    name: `Permissions ${index + 1}`,
  }));
}
export function uniqueByValue(array) {
  const uniqueSet = new Set();
  const result = [];
  // eslint-disable-next-line
  for (const obj of array) {
    const serialized = JSON.stringify(obj);
    if (!uniqueSet.has(serialized)) {
      uniqueSet.add(serialized);
      result.push(obj);
    }
  }

  return result;
}
// Common convert JSON to UI
function commonConvert(dataConvert, dataAll, dataServices) {
  const frameOfPermission = {
    name: null,
    isShow: null,
    allServices: [],
    nameServices: '',
    uuidServices: '',
    permissionGroup: [],
    permissionSelected: [],
    isShowCondition: true,
    conditionByPermission: [],
    conditionSelected: [],
  };
  return dataConvert.reduce((result, currentValue, currentValueIndex) => {
    const itemPermissionCopy = JSON.parse(JSON.stringify(frameOfPermission));
    const {
      parent, // service parent (ex: iam, cloud-server)
      conditionAll, // condition all json
      endpointAll, // permission all json
    } = currentValue;
    itemPermissionCopy.nameServices = parent.toUpperCase();
    itemPermissionCopy.name = `Permissions ${currentValueIndex + 1}`;
    itemPermissionCopy.isShow = setIsShow(!currentValueIndex);
    itemPermissionCopy.allServices = dataServices;
    const filterServices = dataServices
        .filter((ele) => ele.service_name === parent.toUpperCase());
    itemPermissionCopy.uuidServices = filterServices[0].uuid;
    /*
      Get permissionSelected, permissionGroup, conditionByPermission
      From data all (server response)
    */
    dataAll.forEach((service, index) => {
      service.resources.forEach((element) => {
        if (service.service === parent && !itemPermissionCopy.permissionGroup.length) {
          const resourceMappingMethod = mappingMethods(dataAll[index].resources);
          itemPermissionCopy.permissionGroup = groupPermissionByType(resourceMappingMethod);
        }
        // Get permissionSelected
        if (endpointAll.includes(element.endpoint)) {
          const indexNodeParent = itemPermissionCopy.permissionGroup
              .findIndex((node) => node.children.find((child) => child.label === element.endpoint));
          itemPermissionCopy.permissionSelected.push({
            id: element.uuid,
            label: element.endpoint,
            nodeParentIndex: indexNodeParent + 1,
            description: element.description,
            isParent: false,
            disabled: false,
            children: [],
            conditions: element.conditions,
            action: element.action,
          });
        }
      });
    });
    // Get conditionByPermission
    itemPermissionCopy.permissionSelected.forEach((currentValue) => {
      if (currentValue.conditions.length) {
        currentValue.conditions.forEach((condition) => {
          if (!itemPermissionCopy.conditionByPermission.length) {
            itemPermissionCopy.conditionByPermission.push({
              ...condition,
              endpointList: [currentValue.label],
            });
          }
          // different condition_name
          if (!itemPermissionCopy.conditionByPermission
                  .some((ele) => ele.condition_name === condition.condition_name)
              && itemPermissionCopy.conditionByPermission.length) {
            itemPermissionCopy.conditionByPermission.push({
              ...condition,
              endpointList: [currentValue.label],
            });
          }
          // same condition_name
          if (itemPermissionCopy.conditionByPermission
                  .some((ele) => ele.condition_name === condition.condition_name)
              && itemPermissionCopy.conditionByPermission
                  .some((ele) => !ele.endpointList.includes(currentValue.label))
              && itemPermissionCopy.conditionByPermission.length
          ) {
            const index = itemPermissionCopy.conditionByPermission
                .findIndex((e) => e.condition_name === condition.condition_name);
            if (!itemPermissionCopy.conditionByPermission[index]
                .endpointList.includes(currentValue.label)) {
              itemPermissionCopy.conditionByPermission[index]
                  .endpointList.push(currentValue.label);
            }
          }
        });
      }
    });
    // get list name condition and endpoint list
    if (itemPermissionCopy.conditionByPermission.length) {
      const conditionData = itemPermissionCopy.conditionByPermission
          .reduce((data, currentValue) => {
            data.nameList.push(currentValue?.condition_name);
            if (!data.nameList.length) {
              // eslint-disable-next-line
              data.endpointList = currentValue.endpointList;
            } else {
              currentValue.endpointList.forEach((item) => {
                if (!data.endpointList.includes((item))) {
                  data.endpointList.push(item);
                }
              });
            }
            return data;
          }, {
            nameList: [],
            endpointList: [],
          });
      if (conditionData.nameList.length && conditionAll.length) {
        // get conditionSelected
        const dataConditionProcess = conditionAll.map((condition) => {
          const filterConditionFromAll = itemPermissionCopy
              .conditionByPermission
              .filter((item) => item.condition_name === condition.condition_name);
          // get all endpoint by condition name from conditionByPermission
          const getEndpointByName = filterConditionFromAll.reduce((result, currentValue) => {
            if (currentValue.condition_name === condition.condition_name) {
              currentValue.endpointList.forEach((endpoint) => {
                if (!result.includes(endpoint)) result.push(endpoint);
              });
            }
            return result;
          }, []);
          let valueMapping = null;
          if (Array.isArray(condition.value)) {
            valueMapping = condition.value;
          } else {
            valueMapping = [condition.value];
          }
          return {
            condition_name: condition.condition_name,
            compare: condition.compare,
            value: valueMapping,
            endpointByName: getEndpointByName,
            multi_value: filterConditionFromAll[0]?.multi_value,
            is_global: filterConditionFromAll[0]?.is_global,
          };
        });
        itemPermissionCopy.conditionSelected = uniqueByValue(dataConditionProcess);
      }
    }
    // get list condition global
    itemPermissionCopy.conditionSelected.forEach((item) => {
      const isExitsCondition = result.listConditionGlobal
          .some((condition) => item.condition_name === condition.condition_name);
      if (item.is_global && !isExitsCondition) {
        result.listConditionGlobal.push(item);
      } else if (item.is_global && isExitsCondition) {
        const index = result.listConditionGlobal
            .findIndex((condition) => item.condition_name === condition.condition_name);
        const newConditionGlobal = {
          ...result.listConditionGlobal[index],
          endpointByName: [
            ...result.listConditionGlobal[index].endpointByName, ...item.endpointByName,
          ],
        };
        result.listConditionGlobal.splice(index, 1, newConditionGlobal);
      }
    });
    result.data.push(itemPermissionCopy);
    return result;
  }, {
    status: true,
    data: [],
    listConditionGlobal: [],
  });
}
function formatConditionValue(condition) {
  let formatDataValue = null;
  if (condition.multi_value) {
    formatDataValue = condition.value;
  } else {
    formatDataValue = condition.value.join('');
  }
  return {
    condition_name: condition.condition_name,
    compare: condition.compare,
    value: formatDataValue,
  };
}
/*
  * used: convert ui to json, convert data to submit create/update role
 */
function handleDisabledChildTree(permissionGroup) {
  return permissionGroup.map((item) => {
    return {
      ...item,
      children: item.children.map((ele) => ({
        ...ele,
        disabled: true,
      })),
    };
  });
}
/*
  * used: convert ui to json, convert data to submit create/update role
 */
export function convertTreeToJson(dataPermission, listConditionGlobal) {
  const permissionCode = {
    version: '1.0.0',
    permissions: [],
  };
  const itemPermissionDefault = {
    effect: 'allow',
    action: [],
    resources: [],
    conditions: [],
  };
  const filterPermissionHasData = dataPermission
      .filter((item) => item?.permissionSelected.length);
  if (filterPermissionHasData.length) {
    dataPermission.forEach((currentValue) => {
      const { permissionSelected, conditionSelected } = currentValue;
      const listEndpoint = permissionSelected.map((item) => item.label);
      const isMultipleChildService = checkMultipleChildService(listEndpoint);
      if (isMultipleChildService) {
        const resourcesGroup = groupByActionOfResources(permissionSelected, 'action');
        Object.keys(resourcesGroup).forEach((key) => {
          const itemPermissionCopy = JSON.parse(JSON.stringify(itemPermissionDefault));
          itemPermissionCopy.action.push(key);
          resourcesGroup[key].forEach((ele) => {
            const subEndpoint = ele.label.split('.')
                .filter((e) => e !== key).join('.');
            itemPermissionCopy.resources.push(subEndpoint);
            // get condition selected
            conditionSelected.forEach((condition) => {
              const conditionFormat = formatConditionValue(condition);
              if (condition?.endpointByName.includes(ele.label)
                  && !itemPermissionCopy.conditions
                      .some((item) => JSON.stringify(item) === JSON.stringify(conditionFormat))) {
                itemPermissionCopy.conditions.push(conditionFormat);
              }
            });
          });
          // Get condition global
          listConditionGlobal.forEach((conditionGlobal) => {
            const conditionFormat = formatConditionValue(conditionGlobal);
            if (!itemPermissionCopy.conditions
                .some((item) => JSON.stringify(item) === JSON.stringify(conditionFormat))) {
              itemPermissionCopy.conditions.push(formatConditionValue(conditionGlobal));
            }
          });
          permissionCode.permissions.push(itemPermissionCopy);
        });
      } else {
        const permissionCopy = JSON.parse(JSON.stringify(itemPermissionDefault));
        permissionSelected.forEach((permission) => {
          const services = permission.label.split('.')
              .filter((e) => e !== permission.action).join('.');
          if (!permissionCopy.resources.includes(services)) {
            permissionCopy.resources.push(services);
          }
          if (!permissionCopy.action.includes(permission.action)) {
            permissionCopy.action.push(permission.action);
          }
        });
        // Get condition selected
        conditionSelected.forEach((condition) => {
          const conditionFormat = formatConditionValue(condition);
          if (condition.condition_name !== '') {
            permissionCopy.conditions.push(conditionFormat);
          }
        });
        // Get condition global
        listConditionGlobal.forEach((conditionGlobal) => {
          const conditionFormat = formatConditionValue(conditionGlobal);
          if (!permissionCopy.conditions
              .some((item) => JSON.stringify(item) === JSON.stringify(conditionFormat))) {
            permissionCopy.conditions.push(formatConditionValue(conditionGlobal));
          }
        });
        permissionCode.permissions.push(permissionCopy);
      }
    });
  } else {
    permissionCode.permissions = [itemPermissionDefault];
  }
  return permissionCode;
}
/*
  * used: convert data json to tree ui
 */
export function convertJsonToTree(dataRoleJson, dataAll, dataServices) {
  if (dataRoleJson.length === 1 && isDataDefault(dataRoleJson)) {
    return {
      status: true,
      data: [{
        name: 'Permissions 1',
        isShow: false,
        nameServices: '',
        uuidServices: '',
        allServices: dataServices,
        resourceByServices: [],
        permissionGroup: [],
        permissionSelected: [],
        isShowCondition: true,
        conditionByPermission: [],
        conditionSelected: [],
      }],
    };
  }
  // check data action and resources not empty before convert
  // sau nhớ check condition
  const permissionNotEmpty = dataRoleJson.filter((item) => isNotEmptyData(item?.action)
      && isNotEmptyData(item?.resources));
  if (!permissionNotEmpty.length) {
    return {
      status: false,
      data: [],
    };
  }
  // logic new multiple choose
  const dataJsonUpdate = permissionNotEmpty.map((ele) => {
    const serviceParent = ele?.resources[0].split('.')[0];
    return {
      ...ele,
      parent: serviceParent,
    };
  });
  const resourcesGroupByServices = groupByActionOfResources(dataJsonUpdate, 'parent');
  const resourcesGroupMerge = groupResourcesMerge(resourcesGroupByServices);
  if (resourcesGroupMerge.status) {
    return commonConvert(resourcesGroupMerge.dataMerge, dataAll, dataServices);
  }
  return {
    status: false,
    data: [],
    listConditionGlobal: [],
  };
}
/*
  * used: convert data role server to data tree
 */
export function convertDataRoleFromServerToUI(permissionData, dataAll, dataServices, isUpdate) {
  const dataConvert = commonConvert(permissionData.dataMerge, dataAll, dataServices);
  if (!isUpdate) {
    const remapDataGroup = dataConvert.data.map((item) => {
      return {
        ...item,
        permissionGroup: handleDisabledChildTree(item.permissionGroup),
      };
    });
    return {
      status: true,
      data: remapDataGroup,
    };
  }
  return dataConvert;
}
